
<div style="height: 100px;">&nbsp;</div>

<div fxLayout="column" fxLayoutAlign="center center" class="card" >
  <div *ngIf="true">
    <div>
      <div class="header">

        <ng-container *ngIf="type === 'btl'">
          <mat-card>
            <div style="text-align: center; padding-left: 30px; padding-right: 30px;">
              <h1>THANK YOU!</h1>

              You may close this page now.

            </div>
          </mat-card>
        </ng-container>

        <ng-container *ngIf="type === 'order'">

          <ng-container *ngIf="lang === 'de'">
            <mat-card>
              <div style="text-align: center; padding-left: 30px; padding-right: 30px;">
                <h1>DANKE!</h1>

                {{firstname}}, vielen Dank für deine Bestellung. Mit deiner Entscheidung für eine {{product?.name}} Karte hast du eine gute Wahl getroffen. Du erhältst in Kürze eine Bestellbestätigung und kannst diese Seite jetzt schließen.<br />
                <br />
                Mit freundlichen Grüßen nach {{customerCity}}<br />
                <br />
                {{company?.name}}<br />
                Support Team<br />
                eMail: {{company?.supportEmail}}<br />
                Telefon: +{{company?.supportPhone}}<br />
              </div>
            </mat-card>
          </ng-container>

          <ng-container *ngIf="lang === 'en'">
            <mat-card>
              <div style="text-align: center; padding-left: 30px; padding-right: 30px;">
                <h1>THANK YOU!</h1>

                {{firstname}}, thank you for your order. You have made a good decision by choosing a {{product?.name}} card. You will receive an order confirmation shortly and can now close this page.<br />
                <br />
                Best regards to {{customerCity}}<br />
                <br />
                {{company?.name}}<br />
                Support Team<br />
                eMail: {{company?.supportEmail}}<br />
                Telefon: +{{company?.supportPhone}}<br />
              </div>
            </mat-card>
          </ng-container>

        </ng-container>

      </div>
    </div>
    <!--<div class="description">{{ 'ORDER_CANCELLATION.CONFIRMATION.TEXT' | translate }}</div>-->

  </div>
</div>
